import { createNavigationContainerRef } from '@react-navigation/native'

export const navigationRef = createNavigationContainerRef()

let pendingQueue = []

export const flushNavigationQueue = () => {
    try {
        if (!navigationRef.isReady()) return
        const queue = pendingQueue
        pendingQueue = []
        queue.forEach(({ name, params }) => {
            try { navigationRef.navigate(name, params) } catch {}
        })
    } catch {}
}

export const navigateOrEnqueue = (name, params) => {
    if (navigationRef.isReady()) {
        try { navigationRef.navigate(name, params) } catch {}
    } else {
        pendingQueue.push({ name, params })
    }
}

/**
 * @description funcion que simula un useNavigate, tiene un navigationRef que lo toma directamente el navigationContainer
 * @param {*} name nombre de la vista a redireccionar
 * @param {*} params parametros que se se pasa a la vista
 */
export const navigate = (name, params) => navigateOrEnqueue(name, params)

